import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { defineMessages, useIntl } from 'dibs-react-intl';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { BasicSelect } from 'dibs-elements/exports/BasicSelect';
import { updateUriRef } from '../../actions/filterActions';

// styles
import styles from './SbRespSortItems.scss';

const messages = defineMessages({
    label: { id: 'sb.SbRespSortItemsComponent.label', defaultMessage: 'Sort by' },
});

function SbRespSortItemsComponent(props) {
    const intl = useIntl();
    const { itemSearch, onChange } = props;
    const selectedValueUrlLabel = itemSearch?.sort?.currentOption?.urlLabel;
    /**
     * GROWTH-6458: buyPageRelevance param is used for initial buy page rendering. Sort options should use regular 'relevance' sort param.
     */
    const selectedValue =
        selectedValueUrlLabel === 'buyPageRelevance' ? 'relevance' : selectedValueUrlLabel;
    const options = itemSearch.sort?.options?.map(sortOption => {
        return {
            value: sortOption.urlLabel,
            label: sortOption.displayName,
        };
    });

    return (
        <div className={styles.container}>
            <BasicSelect
                ariaLabel={intl.formatMessage(messages.label)}
                size="medium"
                value={selectedValue}
                dataTn="sb-resp-sort-by"
                options={options}
                onChange={e => {
                    onChange(e.target.value, e);
                }}
            />
        </div>
    );
}

SbRespSortItemsComponent.propTypes = {
    itemSearch: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch, { itemSearch }) {
    return {
        onChange(value, event) {
            const filterValue = itemSearch.sort?.options?.find(option => option.urlLabel === value);
            dispatch(updateUriRef({ filterValue, event }));
        },
    };
}

export const SbRespSortItems = createFragmentContainer(
    connect(null, mapDispatchToProps)(SbRespSortItemsComponent),
    {
        itemSearch: graphql`
            fragment SbRespSortItems_itemSearch on ItemSearchQueryConnection {
                sort {
                    options {
                        urlLabel
                        linkReference
                        displayName
                    }
                    currentOption {
                        urlLabel
                    }
                }
            }
        `,
    }
);
